import(/* webpackMode: "eager" */ "/var/www/Fixr/frontend/app/admin/layout.tsx");
